<template>
    <div name="popup">
        <div class="wrapper" v-if="view">
            <img class="img" src="../assets/popup0117.png" />
            <div class="btn-wrapper">
                <span class="text-btn" @click="goSoldocGuide">비대면 진료 시범사업 가이드리안 확인하기</span>
            </div>
            <div class="bottom">
                <span class="button" @click="todayClose">오늘 하루 보이지 않음</span>
                <span class="button" @click="close">CLOSE</span>
            </div>
        </div>

    </div>
</template>

<script>
import cookies from '@/utilities/cookie.js';

export default {
    name: 'popup',
    data: function()
    {
        return {
            view: false,

        }
    },
    mounted: function()
    {
        // 쿠키에 데이터 여부 확인 
        // today == false 면 보이기
        // today == true 면 today의 유효기간 체크 
        // today 의 유효기간(1)이 지났으면 보이기 
        // 지나지 않았으면 안보이기 
        this.view = cookies.getCookie("today");
  
        if(this.view == "false")
        {
            this.view = false;
        }
        else
        {
            this.view = true;
        }
         
    },
    methods: {
        close: function()
        {
            this.view = false;
        },
        todayClose: function()
        {
            this.view = false;
            cookies.setCookie("today", false); 
        },
        goSoldocGuide: function()
        {
            window.open('https://www.mohw.go.kr/react/al/sal0101vw.jsp?PAR_MENU_ID=04&MENU_ID=040101&page=1&CONT_SEQ=376488', '_blank');
        },
    }
}
</script>

<style scoped>
    .wrapper {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: calc(100% - 20%);
        position: fixed;
        z-index: 999;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 999;
    }
    .img{
        width: 100%;
    }
    .bottom{
        height: 28px;
        width: 100%;
        background: #ECF1FF;
        display: flex;
        justify-content: space-between;
        align-items: center;
        /* padding: 0px 20px 0px 20px; */
    }
    .button{
        cursor: pointer;
        font-family: 'Pretendard';
        font-style: normal;
        font-weight: 500;
        font-size: 15px;
        line-height: 32px;
        margin-right: 10px;
        margin-left: 10px;
    }
    .btn-wrapper{
        position: absolute;
        left: 50%;
        bottom: 96px;
        transform: translateX(-50%);
        display: block;
        width: 100%;
        text-align: center;
    }
    .text-btn{
        position: relative;
        font-weight: 600;
        line-height: 26px;
        color: transparent;
        opacity: 0;
        cursor: pointer;
    }
    .text-btn:after{
        position: absolute;
        left: 50%;
        bottom: 0;
        transform: translateX(-50%);
        content: '';
        display: block;
        width: 100%;
        height: 2px;
        /* background-color: #00316D; */
    }
    @media (min-width: 960px) {
        .wrapper {
            width: 366px;
            top: 50%;
            left: calc(50% - 283px);
            transform: translate(0%, -50%);
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/Popup.vue